export default __webpack_public_path__ + "static/media/card_4.a2417ca7.svg";